import { PROJECT_SETTINGS_SECTION_DEFINITIONS } from "../../utils/dashboardNavigation";

export const PROJECT_SETTINGS_SECTIONS = PROJECT_SETTINGS_SECTION_DEFINITIONS;

export function getProjectSettingsSection(pathname = "") {
  if (pathname.includes("/configuracion/funcionalidades")) return "suscripcion";
  const match = PROJECT_SETTINGS_SECTIONS.find((section) =>
    pathname.includes(`/configuracion/${section.value}`),
  );
  return match?.value || "general";
}
